import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiClient } from '../api/apiClient';
import type { DataResponse } from '../types/api';
import { useAuth } from './AuthContext';
import type { UserProfile } from './userProfile';

export function useProfile() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['me', user?.uid],
    queryFn: () =>
      apiClient
        .get<DataResponse<UserProfile>>('/profile')
        .then((r) => r.data.data),
    enabled: !!user,
    staleTime: 10 * 60_000,
    placeholderData: keepPreviousData,
  });
}

export function profileQueryKey(uid: string | undefined) {
  return ['me', uid] as const;
}
